import * as React from 'react';
import { CardLayout } from '../parts';
import { ADVANTAGES_CONTENT } from './content';
import { AdvantagesItem } from './AdvantagesItem';

import * as styles from './styles.css';

export const Advantages: React.FC = () => {
  return (
    <div data-testid="Advantages" className={styles['container']}>
      <CardLayout>
        {ADVANTAGES_CONTENT.map((item, index) => (
          <AdvantagesItem {...item} key={item.description + index} />
        ))}
      </CardLayout>
    </div>
  );
};
